// react
import { useContext } from "react";
// components
import { Container } from "../Container";
import FabButton from "../FabButton";
import { FlexContainer } from "../Flex";
// other
import { TimelineAnimateScrollContext } from "../../context/TimlineAnimateScrollContext";

interface TimelineScrollTopProps {}

export const TimelineScrollTop: React.FC<TimelineScrollTopProps> = ({}) => {
  const { setIsAnimating } = useContext(TimelineAnimateScrollContext);

  const scrollToTop = () => {
    setIsAnimating({ isAnimating: true, color: "salmon" });

    setTimeout(() => {
      window.scrollTo({ top: 0 });
    }, 900);
  };

  return (
    <Container pb={4}>
      <FlexContainer justifyContent="flex-end">
        <FabButton icon="arrowUpward" onClick={() => scrollToTop()} />
      </FlexContainer>
    </Container>
  );
};
